import { gql } from '@apollo/client'

const CREATE_SELECTION_ITEM_MUTATION = gql`
  mutation createColumnSelection($attributes: ColumnSelectionInput!) {
    createColumnSelection(attributes: $attributes) {
      id
      createdAt
      updatedAt
      title
      columns
      user {
        name
      }
    }
  }
`

export default CREATE_SELECTION_ITEM_MUTATION
